// import { useEffect, useRef } from "react";

// const CertikBadge = () => {
//   const emblemRef = useRef(null);

//   useEffect(() => {
//     // Hide emblem initially
//     const style = document.createElement("style");
//     style.innerHTML = ".certik-emblem { display: none; }";
//     document.head.appendChild(style);

//     const injectScript = () => {
//       if (emblemRef.current) {
//         const script = document.createElement("script");
//         script.src = "https://emblem.certik-assets.com/script?pid=rzto&vid=da00bc09";
//         script.async = true;
//         document.body.appendChild(script);
//       } else {
//         requestAnimationFrame(injectScript);
//       }
//     };

//     requestAnimationFrame(injectScript);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         transform: "scale(0.6)",
//         marginLeft: "7px"
//       }}
//     >
//       <div
//         className="certik-emblem"
//         data-id="da00bc09"
//         ref={emblemRef}
//       >
//         <a
//           href="https://skynet.certik.com/projects/rzto?utm_source=SkyEmblem&utm_campaign=rzto&utm_medium=link"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           View project at certik.com
//         </a>
//       </div>
//     </div>
//   );
// };

// export default CertikBadge;

import { useEffect, useRef } from "react";

const CertikBadge = () => {
  const emblemRef = useRef(null);

  useEffect(() => {
    const loadScript = () => {
      if (!emblemRef.current) return;

      // Only add script if it doesn't already exist
      const existingScript = document.querySelector(
        "script[src*='certik-assets.com/script']"
      );
      if (existingScript) return;

      const script = document.createElement("script");
      script.src =
        "https://emblem.certik-assets.com/script?pid=rzto&vid=da00bc09";
      script.async = true;
      document.body.appendChild(script);
    };

    // Wait for next paint/frame
    requestAnimationFrame(() => {
      // Slight delay to ensure DOM is fully ready
      setTimeout(() => {
        loadScript();
      }, 0);
    });

    return () => {
      const existingScript = document.querySelector(
        "script[src*='certik-assets.com/script']"
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div style={{ transform: "scale(0.6)", marginLeft: "7px" }}>
      <div className="certik-emblem" data-id="da00bc09" ref={emblemRef}>
        <a
          href="https://skynet.certik.com/projects/rzto"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </div>
    </div>
  );
};

export default CertikBadge;
